<section id="contact-us" class="contact">
  <div class="contact__container">
    <div class="contact__header">
      <p class="contact__subtitle">CONTACT US</p>
      <h2 class="contact__title">Let's get in touch</h2>
      <div class="contact__divider"></div>
    </div>

    <div class="contact__content">
      <div class="contact__left">
        
        <div class="contact__image"></div>

        <div class="contact__left-header">
          <h2 class="contact__left-title">Get Your Quote Now!</h2>
          <p class="contact__left-desc">
            Call us today or leave your phone number to get a same-day project quote. It's absolutely free for you, and fast and professional from us.
          </p>
        </div>

        <div class="contact__info-grid">
          
            <a [href]="'tel:' + contactInfo().phone" class="contact__info-box">
              <span class="contact__info-icon">
                <img src="contact/phone.svg" alt="Phone" class="contact__info-svg" />
              </span>
              <span class="contact__info-text">
                <strong>Phone</strong>
                  0493 439 216
              </span>
            </a>

            <a [href]="'mailto:' + contactInfo().email" class="contact__info-box">
              <span class="contact__info-icon">
                <img src="contact/mail.svg" alt="Email" class="contact__info-svg" />
              </span>
              <span class="contact__info-text">
                <strong>Email</strong>
                  info@lexwoodsolutions.com.au
              </span>
            </a>

            <a href="https://maps.app.goo.gl/TcPzGMPx3uGGoM9b8" target="_blank" rel="noopener noreferrer" class="contact__info-box">
              <span class="contact__info-icon">
                <img src="../arrow-down.svg" alt="Address" class="contact__info-svg" />
              </span>
              <span class="contact__info-text">
                <strong>Address</strong>
                Waitara, Sydney,  NSW 
              </span>
            </a>

            <div class="contact__info-box">
              <span class="contact__info-icon">
                <img src="../favicon.svg" alt="Licence" class="contact__info-svg" />
              </span>
              <span class="contact__info-text">
                <strong>Licence</strong>
                Licensed Carpentry Contractor (NSW) - Licence No: 468652C
              </span>
            </div>

            <div class="contact__info-box">
              <span class="contact__info-icon">
                <img src="../favicon.svg" alt="Insure" class="contact__info-svg" />
              </span>
              <span class="contact__info-text">
                <strong>Insurance</strong>
                Fully Insured Contractors ($20M Public Liability)
              </span>
            </div>

          </div>

      </div>

      <div class="contact__right" >
        <form class="contact__form" [formGroup]="contactForm" (ngSubmit)="onSubmit()">

          <div class="contact__badge">Get a Quote in 24 Hours!</div>

          <div class="form-group">
            <input
              type="text"
              id="name"
              formControlName="name"
              class="form-group__input"
              placeholder="NAME (OPTIONAL)" />
          </div>

          <div class="form-group">
            <input
              type="text"
              id="phone"
              formControlName="phone"
              autocomplete="on"
              class="form-group__input"
              [class.form-group__input--error]="f['phone'].invalid && f['phone'].touched"
              placeholder="PHONE NUMBER (REQUIRED)" />
            @if (f['phone'].invalid && f['phone'].touched) {
              <div class="form-group__error">
                <span class="form-group__error-text">{{ getPhoneErrorMessage() }}</span>
              </div>
            }
          </div>

          <div class="form-group form-group--services">
            <div class="form-group__label-row">
              <label class="form-group__label">SERVICES (OPTIONAL)</label>
              <button type="button" class="form-group__reset-link" (click)="resetServices()">Reset</button>
            </div>
            <div class="form-group__services-grid">
              @for (service of availableServices(); track service.id) {
                <label class="service-checkbox">
                  <input
                    type="checkbox"
                    class="service-checkbox__input"
                    [checked]="service.selected"
                    (change)="toggleService(service.id)" />
                  <span class="service-checkbox__checkmark"></span>
                  <span class="service-checkbox__label">{{ service.label }}</span>
                </label>
              }
            </div>
          </div>

          <div class="form-group">
            <textarea
              id="message"
              formControlName="message"
              class="form-group__textarea"
              placeholder="MESSAGE (OPTIONAL)"
              rows="5"></textarea>
          </div>

          <div class="contact__submit-container">
            <div class="contact__messages">
              @if (serverValidationError) {
                <div class="contact__error-server">
                  <span class="contact__error-text">{{ serverValidationError }}</span>
                </div>
              }
              @if (successMessage) {
                <div class="contact__success">
                  <span class="contact__success-icon">✓</span>
                  <span class="contact__success-text">{{ successMessage }}</span>
                </div>
              }
            </div>

            <button
              type="submit"
              class="contact__form-btn"
              [disabled]="contactForm.invalid || isSubmitting">
              {{ isSubmitting ? 'Sending...' : 'SEND MESSAGE' }}
            </button>
          </div>          
        </form>
      </div>
    </div>
  </div>
</section>